<template>
  <div class="pa-4">
    <v-app-bar flat color="transparent" class="mb-2">
      <v-btn icon @click="$router.go(-1)">
        <v-icon color="primary">mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title class="title">Revisar DLL</v-toolbar-title>
    </v-app-bar>

    <v-alert type="info" outlined dense class="mb-4">
      Depois de reiniciar a API, cada schema é compilado no primeiro acesso e aparecem erros de "DLL" até isso acontecer.
      Esta tela abre todos os schemas de uma vez (somente leitura: lê o schema e 1 registro de cada). Roda um schema por vez, então pode levar alguns minutos.
    </v-alert>

    <v-card outlined class="pa-4">
      <v-btn color="primary" :loading="executando" :disabled="executando" @click="revisar">
        <v-icon left>mdi-database-refresh</v-icon> Revisar DLL
      </v-btn>

      <div v-if="total" class="mt-4">
        <v-progress-linear :value="percentual" height="20" rounded :color="erros.length ? 'warning' : 'success'">
          <strong>{{ processados }} / {{ total }}</strong>
        </v-progress-linear>
        <div class="mt-3">
          <v-chip class="mr-2" color="success" outlined>OK: {{ ok }}</v-chip>
          <v-chip color="error" outlined>Com erro: {{ erros.length }}</v-chip>
          <span v-if="terminou" class="ml-3 caption">Concluído em {{ duracao }} s.</span>
        </div>
      </div>

      <v-alert v-if="mensagem" type="error" dense outlined class="mt-4">{{ mensagem }}</v-alert>

      <v-simple-table v-if="erros.length" dense class="mt-4">
        <template v-slot:default>
          <thead><tr><th>Schema</th><th>Etapa</th><th>Mensagem</th></tr></thead>
          <tbody>
            <tr v-for="(e, i) in erros" :key="i">
              <td>{{ e.nome }}</td><td>{{ e.etapa }}</td><td>{{ e.msg }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <div v-if="terminou && erros.length" class="caption mt-2">
        Erros isolados costumam ser do próprio schema/dados daquela entidade, não da DLL. Rode de novo para confirmar.
      </div>
    </v-card>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'RevisarDllView',
  data() {
    return { executando: false, terminou: false, total: 0, processados: 0, ok: 0, erros: [], mensagem: '', duracao: 0 }
  },
  computed: {
    percentual() { return this.total ? Math.round((this.processados / this.total) * 100) : 0 },
  },
  methods: {
    async listarSchemas(http) {
      let nomes = []
      let page = 1
      let pages = 1
      do {
        const r = await http.get(`/Schema?page=${page}&limit=200`)
        const d = r && r.data && r.data.data
        if (!d || !Array.isArray(d.data)) throw new Error('Não foi possível listar os schemas.')
        nomes = nomes.concat(d.data.map(s => s.name))
        pages = d.pages || 1
        page++
      } while (page <= pages)
      return [...new Set(nomes.filter(Boolean))]
    },
    async acessar(http, nome, url, etapa) {
      try {
        const r = await http.get(url)
        const falhou = !r || r.status !== 200 || (r.data && r.data.success === false)
        if (falhou) { this.erros.push({ nome, etapa, msg: JSON.stringify(r && r.data).slice(0, 200) }); return false }
        return true
      } catch (e) {
        this.erros.push({ nome, etapa, msg: String(e && e.message).slice(0, 200) })
        return false
      }
    },
    async revisar() {
      const http = Vue.prototype.$http
      this.executando = true
      this.terminou = false
      this.mensagem = ''
      this.erros = []
      this.total = 0
      this.processados = 0
      this.ok = 0
      const inicio = Date.now()
      try {
        const nomes = await this.listarSchemas(http)
        this.total = nomes.length
        let i = 0
        const worker = async () => {
          while (i < nomes.length) {
            const nome = nomes[i++]
            const a = await this.acessar(http, nome, `/Schema/${nome}`, 'Schema')
            const b = await this.acessar(http, nome, `/Entity/${nome}?limit=1`, 'Entity')
            if (a && b) this.ok++
            this.processados++
          }
        }
        // Sequencial de propósito: a API compila a DLL de cada schema no 1º acesso e grava o arquivo em disco;
        // duas requisições compilando o mesmo schema ao mesmo tempo podem corromper a DLL ("Bad IL format").
        await worker()
        this.duracao = Math.round((Date.now() - inicio) / 1000)
        this.terminou = true
      } catch (e) {
        this.mensagem = e.message || 'Falha ao revisar.'
      } finally {
        this.executando = false
      }
    },
  },
}
</script>
